module.exports = __webpack_public_path__ + "img/bandage.334eff4e.svg";